module.exports = __webpack_public_path__ + "img/p4.263a896f.png";